import React, { useState } from 'react';
import { addTopic } from '../../services/topicService';
import { UserService } from '../../services/userService';
import './TopicForm.css';

interface TopicFormProps {
  user?: any;
  onTopicAdded?: () => void;
}

const TopicForm: React.FC<TopicFormProps> = ({ user, onTopicAdded }) => {
  const [topicValue, setTopicValue] = useState('');
  const [isCommon, setIsCommon] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState<string | null>(null);

  // Check if user is admin
  const isAdmin = UserService.isAdmin(user);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (!topicValue.trim()) {
      setError('Please enter a topic');
      return;
    }

    setIsSubmitting(true);
    setError(null);

    try {
      const topicType = isCommon && isAdmin ? 'COMMON' : 'USER';
      await addTopic(topicValue.trim(), topicType, user?.id);
      setTopicValue('');
      setIsCommon(false);
      onTopicAdded?.();
    } catch (error) {
      setError('Failed to add topic. Please try again.');
      console.error('Error adding topic:', error);
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <div className="topic-form">
      <form onSubmit={handleSubmit}>
        <div className="form-group">
          <input
            type="text"
            value={topicValue}
            onChange={(e) => setTopicValue(e.target.value)}
            placeholder="Enter your topic..."
            disabled={isSubmitting}
            className="topic-input"
          />
          <button 
            type="submit" 
            disabled={isSubmitting || !topicValue.trim()}
            className="submit-button"
          >
            {isSubmitting ? 'Adding...' : 'Add Topic'}
          </button>
        </div>
        {error && <div className="error-message">{error}</div>}
      </form>
      
      {isAdmin && (
        <div className="common-toggle-card">
          <div className="toggle-content">
            <div className="toggle-control">
              <label className="checkbox-label">
                <span className="checkbox-text">Make this a common topic?</span>
                <input
                  type="checkbox"
                  checked={isCommon}
                  onChange={(e) => setIsCommon(e.target.checked)}
                  disabled={isSubmitting}
                  className="common-checkbox"
                />
              </label>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default TopicForm;